export function handleAbsterMessage() {
  const message = "HI, I AM ABSTER, ONE OF THE MOST POPULAR TOKENS IN BASE CHAIN. THIS IS MY CONTRACT: 0x9cfe7b403f76f7d2631ef83331aaa93707217271";
  showTypingModal(message);
  logToConsole(message);
}